import en_master_goods from "../../page/master/goods/language/en_master_goods"
import common from "./app/common_en"
import { en_goods } from "./app/master/goods"
import { en_groups } from "./app/master/group"

const main_en_language = {
	translation: {
		common,
		crop_img: { crop: "crop", ok: "crop image" },
		menu: {
			dashboard: "dashboard",
			warehouse: "cek gudang",
			whstrans: "warehouse transaction",
			master: "settings",
			sales: "sales",
			ecommerce: "E-commerce",
			ecommregister: "1Toko registration",
			ecommlist: "E-commerce List",
			purchase: "purchase",
			payment: "payment",
			supplychain: "supply chain",
			supplychain_point: "distribution point",
			supplychain_request: "goods request",
			report: "report",
			rka: "Planning & Budgeting",
			consignment: "consignment",
			groups: 'goods group',
		},
		mitra: {
			"": "goods request",
			detail: "goods request detail",
			additemreq: "add goods request",
			edititemreq: "edit goods request",
		},
		login: {
			title: "Login",
			password: "Password",
			forgotpass: "Forgot Password ?",
			submit: "Submit",
		},
		dashboard: {
			search: { title: "Search", placeholder: "Company ID" },
		},
		warehouse: {},
		whstrans: {},
		master_goods: en_master_goods,
		master: {
			convertionadd: "add goods convertion",
			convertionedit: "edit goods convertion",
			finance: "finance",
			goods: en_goods,
			supplier: {
				add: "add supplier",
				edit: "edit supplier",
			},
			sales: {
				add: "add sales",
				edit: "edit sales",
			},
			customer: {
				add: "add customer",
				edit: "edit customer",
			},
			courier: {
				add: "add courier",
				edit: "edit courier",
			},
			groups: en_groups,
			profileadd: "add profile",
			profileedit: "edit profile",
			process: {
				"": "master process",
				add: "add process",
				edit: "edit process",
			},
			storage: {
				room: "room",
				add: "add storage",
				edit: "edit storage",
				model: "storage model",
			},
			bankacc: {
				bank: "bank",
				norek: "account number",
				namerek: "account name",
				add: "add bank account",
				edit: "edit bank account",
			},
			payment_meth: {
				"": "payment method",
				time: "time (day)",
				add: "add payment method",
				edit: "edit payment method",
			},
			po_fee: {
				other_costs: "other costs",
				local: "Local",
				import: "Import",
			},
			tnc: {
				"": "trem and condition",
			},
			user: {
				"": "user",
				add: "add user",
				edit: "edit user",
			},
			whs_setting: {
				"": "warehouse setting",
				add: "add warehouse",
				edit: "edit warehouse",
			},
			brand: {
				// "": "brand",
				// "name": "brand name",
				// add: "add brand",
				// edit: "edit brand",
				"": "principal",
				"name": "principal name",
				add: "add principal",
				edit: "edit principal",
			}
		},
		spal: {
			addspal: "add contract",
			editspal: "edit contract",
			addpaymentmethod: "add payment method ( contract )",
			editpaymentmethod: "edit payment method ( contract )",
			addtime: "add load & unload time ( contract )",
			edittime: "edit load & unload time ( contract )",
			adddemurrage: "add late charge ( contract )",
			editdemurrage: "edit late charge ( contract )",
			form: {
				paymentmethod: "payment method",
				demurrage: "late charge",
				time: "load & unload time",
			},
		},
		supplychain: {
			"": "supplychain",
			add: "add distribution point",
			edit: "edit distribution point",
			addgoodsreq: "add goods request",
			editgoodsreq: "edit goods request",
			detailgoodsreq: "goods request detail",
		},
		transaction: {
			common: {
				whs: "warehouse",
				search_ref: "search reference",
				trans_id: "tranasaction ID",
				add_item: "add item",
			},
			convertion: {
				"": "convertion",
				add: "add convertion",
			},
			initstock: {
				"": "init stock",
			},
			itemin: {
				"": "item in",
			},
			iteminlist: {
				"": "item in supervision",
				detail: "detail item in",
			},
			itemout: {
				"": "item out",
			},
			itemoutlist: {
				"": "item out supervision",
				detail: "detail item out",
			},
			itemstock: {
				"": "item stock",
			},
			itemmove: {
				"": "movement of goods",
			},
			itemprocess: {
				"": "process goods",
			},
			stockopname: {
				"": "stock opname",
				add: "add stock opname",
				edit: "edit stock opname",
				detail: "stock opname detail",
			},
			returncuslist: {
				"": "return customer supervision",
				"view": "detail return customer ",
				"add": "add return customer ",
				"payment": "return customer payment",
			},
			returnsuplist: {
				"": "return supplier supervision",
				"view": "detail return supplier",
				"add": "add return supplier",
			}
		},
		sales: {
			recap: {
				"": "sales invoice recap",
				add: "add sales invoice recap",
				detail: "sales invoice recap detail",
			},
			returncustomer: {
				"": "return customer",
				type: 'return method'
			},
		},
		purch: {
			recap: {
				"": "purchase invoice recap",
				add: "add purchase invoice recap",
				detail: "purchase invoice recap detail",
			},
			returnsupplier: {
				"": "return supplier",
				type: 'return method'
			},
			po: {
				"": "purchase order",
				create: "add purchase order",
				edit: "edit purchase order",
				create_mitra: "add mitra purchase order",
				edit_mitra: "edit mitra purchase order",
				currency: "currency",
				additional_cost: "additional cost",
				additional_discount: "additional discount",
				price_history: "price history",
				po_detail: "purchase order detail",
			},
		},
		payment: {
			debit: {
				add: "create debit",
				detail: "detail debit",
			},
			credit: {
				add: "create credit",
				detail: "detail credit",
			}
		},
		consignment: {
			"": "consignment",
			detail: "consignment detail",
			form: "consignment input",
			add: "create consignment",
		},
		report: {},
		rka: {
			"": "Planning & Budgeting",
			planning: {
				"": "planning",
				add: "create plan",
				edit: "edit plan",
			},
		},
	},
}

export default main_en_language
